import { createRouter, createWebHistory } from 'vue-router';

import { frontendURL } from '../helper/URLHelper';
import dashboard from './dashboard/dashboard.routes';
import store from 'dashboard/store';
import { validateLoggedInRoutes } from '../helper/routeHelpers';
import { isOnOnboardingView } from 'v3/helpers/RouteHelper';
import AnalyticsHelper from '../helper/AnalyticsHelper';

const ONBOARDING_STEPS = ['account_details', 'enrichment'];
const routes = [...dashboard.routes];

export const router = createRouter({ history: createWebHistory(), routes });

const needsSubscriptionSetup = ({ to, user, fallbackAccountId }) => {
  const shouldCheckSubscriptionRoute =
    !to.name || to.name === 'no_accounts';
  if (!shouldCheckSubscriptionRoute) {
    return false;
  }

  const isOnChatwootCloud = store.getters['globalConfig/isOnChatwootCloud'];
  if (!isOnChatwootCloud) {
    return false;
  }

  const accountId = Number(to.params.accountId || fallbackAccountId);
  const availableAccounts = user.accounts || [];
  const currentAccount = availableAccounts.find(account => Number(account.id) === accountId);

  if (!currentAccount) {
    return false;
  }

  const isAdmin =
    currentAccount.role === 'administrator' ||
    currentAccount.permissions?.includes('administrator');

  if (!isAdmin || to.name === 'billing_settings_index') {
    return false;
  }

  return currentAccount.custom_attributes?.payment_method_added !== true;
};

export const validateAuthenticateRoutePermission = (to, next) => {
  const { isLoggedIn, getCurrentUser: user } = store.getters;

  if (!isLoggedIn) {
    window.location.assign('/app/login');
    return '';
  }

  const { accounts = [], account_id: accountId } = user;
  const routeAccountId = to.params.accountId || accountId;
  const currentAccount = accounts.find(
    account => Number(account.id) === Number(routeAccountId)
  );
  const onboardingStep = currentAccount?.custom_attributes?.onboarding_step;
  const needsOnboarding = ONBOARDING_STEPS.includes(onboardingStep);

  if (!accounts.length) {
    if (to.name === 'no_accounts') {
      return next();
    }
    return next(frontendURL('no-accounts'));
  }

  if (needsSubscriptionSetup({ to, user, fallbackAccountId: accountId })) {
    const targetAccountId = routeAccountId;
    return next(
      frontendURL(`accounts/${targetAccountId}/settings/subscriptions`)
    );
  }

  if (to.name === 'no_accounts' || !to.name) {
    const target = needsOnboarding ? 'onboarding' : 'dashboard';
    return next(frontendURL(`accounts/${routeAccountId}/${target}`));
  }

  const shouldEnforceOnboardingRoute = ['home', 'inbox_dashboard'].includes(
    to.name
  );

  if (
    needsOnboarding &&
    shouldEnforceOnboardingRoute &&
    !isOnOnboardingView(to)
  ) {
    return next(frontendURL(`accounts/${routeAccountId}/onboarding`));
  }
  if (!needsOnboarding && isOnOnboardingView(to)) {
    return next(frontendURL(`accounts/${routeAccountId}/dashboard`));
  }

  const nextRoute = validateLoggedInRoutes(to, store.getters.getCurrentUser);
  return nextRoute ? next(frontendURL(nextRoute)) : next();
};

export const initalizeRouter = () => {
  const userAuthentication = store.dispatch('setUser');

  router.beforeEach(async (to, _from, next) => {
    AnalyticsHelper.page(to.name || '', {
      path: to.path,
      name: to.name,
    });

    await userAuthentication;
    await validateAuthenticateRoutePermission(to, next, store);
  });
};

export default router;
